import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import I18nextBrowserLanguageDetector from "i18next-browser-languagedetector";

import enMenu from "./locales/en/menu.json";
import roMenu from "./locales/ro/menu.json";
import ltMenu from "./locales/lt/menu.json";

import enHomepage from "./locales/en/homepage.json";
import roHomepage from "./locales/ro/homepage.json";
import ltHomepage from "./locales/lt/homepage.json";

import enProfile from "./locales/en/profile.json";
import roProfile from "./locales/ro/profile.json";
import ltProfile from "./locales/lt/profile.json";

import enCitizens from "./locales/en/citizens.json";
import roCitizens from "./locales/ro/citizens.json";
import ltCitizens from "./locales/lt/citizens.json";

import enBasicInfo from "./locales/en/basicInfo.json";
import roBasicIfo from "./locales/ro/basicInfo.json";
import ltBasicInfo from "./locales/lt/basicInfo.json";

import enStatisticsTabs from "./locales/en/statisticsTabs.json";
import roStatisticsTabs from "./locales/ro/statisticsTabs.json";
import ltStatisticsTabs from "./locales/lt/statisticsTabs.json";

import enStatistics from "./locales/en/statistics.json";
import roStatistics from "./locales/ro/statistics.json";
import ltStatistics from "./locales/lt/statistics.json";

import enRiskInfo from "./locales/en/riskInfo.json";
import roRiskInfo from "./locales/ro/riskInfo.json";
import ltRiskInfo from "./locales/lt/riskInfo.json";

import enQuestionnaires from "./locales/en/questionnaires.json";
import roQuestionnaires from "./locales/ro/questionnaires.json";
import ltQuestionnaires from "./locales/lt/questionnaires.json";

import enRecommendations from "./locales/en/recommendations.json";
import roRecommendations from "./locales/ro/recommendations.json";
import ltRecommendations from "./locales/lt/recommendations.json";

import enErrors from "./locales/en/errors.json";
import roErrors from "./locales/ro/errors.json";
import ltErrors from "./locales/lt/errors.json";

import enFooter from "./locales/en/footer.json";
import roFooter from "./locales/ro/footer.json";
import ltFooter from "./locales/lt/footer.json";

import enChat from "./locales/en/chat.json";
import roChat from "./locales/ro/chat.json";
import ltChat from "./locales/lt/chat.json";

import enDocumentation from "./locales/en/documentation.json";
import roDocumentation from "./locales/ro/documentation.json";
import ltDocumentation from "./locales/lt/documentation.json";

import enNotifications from "./locales/en/notifications.json";
import roNotifications from "./locales/ro/notifications.json";
import ltNotifications from "./locales/lt/notifications.json";

import enResearchDocuments from "./locales/en/researchDocuments.json";
import roResearchDocuments from "./locales/ro/researchDocuments.json";
import ltResearchDocuments from "./locales/lt/researchDocuments.json";

import enExport from "./locales/en/export.json";
import roExport from "./locales/ro/export.json";
import ltExport from "./locales/lt/export.json";

import enLogin from "./locales/en/login.json";
import roLogin from "./locales/ro/login.json";
import ltLogin from "./locales/lt/login.json";

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const resources = {
  en: {
    menu: enMenu,
    homepage: enHomepage,
    profile: enProfile,
    citizens: enCitizens,
    basicInfo: enBasicInfo,
    statisticsTabs: enStatisticsTabs,
    statistics: enStatistics,
    riskInfo: enRiskInfo,
    questionnaires: enQuestionnaires,
    recommendations: enRecommendations,
    errors: enErrors,
    footer: enFooter,
    chat: enChat,
    documentation: enDocumentation,
    notifications: enNotifications,
    researchDocuments: enResearchDocuments,
    export: enExport,
    login: enLogin,
  },
  ro: {
    menu: roMenu,
    homepage: roHomepage,
    profile: roProfile,
    citizens: roCitizens,
    basicInfo: roBasicIfo,
    statisticsTabs: roStatisticsTabs,
    statistics: roStatistics,
    riskInfo: roRiskInfo,
    questionnaires: roQuestionnaires,
    recommendations: roRecommendations,
    errors: roErrors,
    footer: roFooter,
    chat: roChat,
    documentation: roDocumentation,
    notifications: roNotifications,
    researchDocuments: roResearchDocuments,
    export: roExport,
    login: roLogin,
  },
  lt: {
    menu: ltMenu,
    homepage: ltHomepage,
    profile: ltProfile,
    citizens: ltCitizens,
    basicInfo: ltBasicInfo,
    statisticsTabs: ltStatisticsTabs,
    statistics: ltStatistics,
    riskInfo: ltRiskInfo,
    questionnaires: ltQuestionnaires,
    recommendations: ltRecommendations,
    errors: ltErrors,
    footer: ltFooter,
    chat: ltChat,
    documentation: ltDocumentation,
    notifications: ltNotifications,
    researchDocuments: ltResearchDocuments,
    export: ltExport,
    login: ltLogin,
  },
};

i18n
  .use(I18nextBrowserLanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    supportedLngs: ["en", "ro", "lt"],
    fallbackLng: "en",
    load: "languageOnly",
    ns: [
      "menu",
      "homepage",
      "profile",
      "citizens",
      "basicInfo",
      "statisticsTabs",
      "statistics",
      "riskInfo",
      "questionnaires",
      "recommendations",
      "errors",
      "footer",
      "chat",
      "documentation",
      "notifications",
      "researchDocuments",
      "export",
      "login",
    ],
    defaultNS: "menu",
    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      caches: ["localStorage"],
    },
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
